// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__-mxNq","imageUploader":"EGiftCard_imageUploader__1-Lfd"};